export enum checklistPersonStatus {
  FINALIZE_PERSONAL_DATA = 'finalize-personal-data',
  IDENTITY = 'identity',
  RETAKE_SELFIE = 'retake-selfie',
  SELFIE = 'selfie',
  ACCOUNT_PASSWORD = 'account-password',
  VALIDATION = 'validation',
  DONE = 'done',
  SPOUSE_REGISTER = 'spouse-register',
}
